import React, { FC } from 'react'
import { cn } from 'shared/utils'

import { configKeysMap, getChartAttr } from 'shared/utils/chartConfig'
import { IStreamPlaylistAutoArgumentsStory } from './AutoStoryArticleContain.props'

import './AutoStoryArticleContent.scss'

const AutoStoryArticleStream: FC<{ storyProperties: IStreamPlaylistAutoArgumentsStory }> = ({ storyProperties }) => (
  <div className="auto-story-stream">
    {storyProperties.platforms
      .sort(
        (platformA, platformB) =>
          configKeysMap.indexOf(platformB.customerId.toLowerCase()) -
          configKeysMap.indexOf(platformA.customerId.toLowerCase())
      )
      .map((platform) => {
        const chartMeta = getChartAttr(platform.customerId.toLowerCase())

        return (
          <div className="auto-story-stream__row" key={platform.customerId}>
            <div className="auto-story-stream__title">
              <div className={`${chartMeta?.icon || ''}`} />
              <h5>{chartMeta.name || platform.customerId}</h5>
            </div>
            {platform.playlists.map((playlist, idx) => (
              <div className="auto-story-stream__playlist" key={idx}>
                {playlist.url ? (
                  <a href={playlist.url} target="_blank" rel="noreferrer">
                    [NEW]{playlist.displayName}
                  </a>
                ) : (
                  `${playlist.isNew ? '[NEW]' : ''}${playlist.displayName}`
                )}
                {playlist.countryId && `[${playlist.countryId}]`}&nbsp;
                {playlist.ownerType && `[${playlist.ownerType}]`}&nbsp;
                <span className={cn({ up: playlist.isUp, down: playlist.isDown })}>
                  #{playlist.position}
                  {playlist.isUp && '▲'}
                  {playlist.isDown && '▼'}&nbsp;
                </span>
                <b>{playlist.isPeak ? '⚡[PEAK]' : ''}</b>
              </div>
            ))}
          </div>
        )
      })}
  </div>
)

export default AutoStoryArticleStream
